import React from "react";

const SellerLocationContext = React.createContext();

export default SellerLocationContext;